// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1659":"422e2904","1762":"8a548f62","2471":"4a477198","4955":"6cf1d65a","7440":"9415c8e7"}[chunkId] + ".chunk.css";
};